module.exports = __webpack_public_path__ + "img/1.3780cc41.svg";